import { useEffect } from 'react';
import { useApi } from './useApi';
import { applyDisplayDefaults, type DisplayDefaults } from './useDisplaySettings';

/**
 * Applies the per-location display defaults (theme / clock / font-size /
 * screensaver-allowed) configured in the portal (location.app_config
 * .displayDefaults, hierarchy-merged server-side) on launch / when the building
 * config changes. Live changes also arrive via the `display_settings` MQTT/WS
 * command (see useMqttCommands); this hook covers cold start and reconnect.
 *
 * The building config endpoint returns `{ success, data: { building: {...} } }`;
 * useApi unwraps the envelope, so we read `data.building.displayDefaults`.
 */
export function useBuildingDisplayDefaults(buildingId: number | undefined) {
  const { data } = useApi<{ building?: { displayDefaults?: DisplayDefaults } }>(
    buildingId ? `/api/v1/building/${buildingId}/config` : null,
  );

  useEffect(() => {
    const dd = data?.building?.displayDefaults;
    if (dd) applyDisplayDefaults(dd);
  }, [data]);
}
